import { SortCriteria } from '@/models/jobs/sortcriteria';
import { mutation } from 'vuex-class-component';
import { FilterModel } from './FilterModel';
import { LocationInfo } from './LocationInfo';

export class JobSearchRequestPayload {
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public jobParamRequests: FilterModel[] = [];
  public locationInfo: LocationInfo = new LocationInfo();
  public sortCriteria: SortCriteria = new SortCriteria();
}
